/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useEffect, useContext, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import Slider from "react-slick";
import secureLocalStorage from "react-secure-storage";
import { Link, useNavigate } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import CryptoJS from "crypto-js";
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Video from "yet-another-react-lightbox/plugins/video";
const Details = () => {
    const { t } = useTranslation();

    const { ApiBasUrl, ImgBasUrl, setTotalCart, totalcart, SECRET_KEY } = useContext(MyContext);

    const [banner, setBanner] = useState([]);
    const [tag, setTag] = useState([]);
    const [whatsinclude, setWhatsInclude] = useState("");
    const [additional, setAdditional] = useState("");
    const [faqList, setFaqList] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState("");
    const [loading, setLoading] = useState(true);
    const [price, setPrice] = useState("");
    const [servicetype, setServiceType] = useState("");
    const [apiloading, setApiLoading] = useState(false);
    const [selectoil, setSelectOil] = useState("");
    const [servicelist, setServiceList] = useState([]);
    const [isshow, setIsShow] = useState(false);
    const [addcart, setAddCart] = useState([]);
    const [totalcartprice, setTotalCartPrice] = useState(0);
    const [cartitem, setCartItem] = useState([]);
    const [itemcopy, setItemCopy] = useState("");
    const [packagecartitem, setPackageCartItem] = useState([]);
    const [status, setStatus] = useState(false);
    const [lightboximg, setLightBoxImg] = useState([]);
    const [showlightbox, setShowLightBox] = useState(false);
    const [lightboxindex, setLightBoxIndex] = useState(0);

    const navigate = useNavigate();

    const servicedata = secureLocalStorage.getItem("servicedata");
    const Currency = secureLocalStorage.getItem("currency");
    const Userid = secureLocalStorage.getItem("Userid");

    if (servicedata) {
        var { service_id, title } = JSON.parse(servicedata);
    }

    const slidesToShow = banner?.length >= 4 ? 4 : banner?.length;

    const settings = {
        dots: false,
        infinite: false,
        arrows: false,
        speed: 500,
        slidesToShow,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1510, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    useEffect(() => {
        const SelectCar = secureLocalStorage.getItem("Selectcar");
        const SelectStore = secureLocalStorage.getItem("Store");

        if (SelectCar && SelectStore) {
            var { brand_id, model_id } = JSON.parse(SelectCar);
            var { store_id } = JSON.parse(SelectStore);
        }

        axios.post(`${ApiBasUrl}/service_info.php`, { service_id, brand_id: brand_id || "1", model_id: model_id || "1", store_id: store_id || "1" })
            .then((res) => {
                console.log(res);
                const { media_files, tags, whats_include, additional_service, faqs, discount_price, service_type, discount_percentage, price, service_img, service_subtitle, service_title } = res.data;
                setBanner(media_files);
                setWhatsInclude(whats_include);
                setAdditional(additional_service);
                setFaqList(faqs);
                setTag(tags);
                setPrice(discount_price);
                setServiceType(service_type);
                setItemCopy({
                    discount_percentage,
                    discount_price,
                    price, service_id, service_img,
                    service_subtitle, service_title,
                    service_type,
                    item_type: "service"
                });

                const Filterimg = media_files.map((item) => {
                    const videoTypes = ['mp4', 'mkv', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mpeg', 'mpg', '3gp', 'm2ts', 'mts'];
                    const fileExt = item.split('.').pop().toLowerCase();

                    if (videoTypes.includes(fileExt)) {
                        return {
                            type: "video", width: 1280, height: 720, sources: [{ src: ImgBasUrl + item, type: "video/mp4" }]
                        };
                    } else {
                        return { type: "image", src: ImgBasUrl + item };
                    }
                });

                setLightBoxImg(Filterimg);
                setLoading(false);
            })
            .catch((error) => {
                console.error("service_info.php", error);
            });

        const localCartItem = localStorage.getItem("Cartitem");

        if (localCartItem) {
            const bytes = CryptoJS.AES.decrypt(localCartItem, SECRET_KEY);
            const { packagecartitem, cartitem } = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            const isAdded = packagecartitem.find(item => item.service_id === service_id);
            setStatus(isAdded);

            if (packagecartitem.length > 0 || cartitem.length > 0) {
                const TotalCart = packagecartitem.length + cartitem.length;
                setTotalCart(TotalCart);
                setPackageCartItem(packagecartitem || []);
                setCartItem(cartitem);
                const totalAddonPrice = cartitem.reduce((sum, item) => sum + item.price, 0);
                setTotalCartPrice(totalAddonPrice);
            }
            const CartId = cartitem.map(item => item.addon_id);
            setAddCart(CartId);
        }

    }, []);

    const handleChange = (index) => {
        const Index = expandedIndex === index ? "" : index;
        setExpandedIndex(Index);
    };

    const handleAddToCart = async () => {

        if (status) {
            navigate("/cart", { state: { title: "Details", path: "/details" } });
            return;
        }

        if (servicetype === "addon") {

            setIsShow(true);
            setApiLoading(true);

            const SelectCar = secureLocalStorage.getItem("Selectcar");
            const SelectStore = secureLocalStorage.getItem("Store");

            if (!SelectCar || !SelectStore) return;

            try {

                const { brand_id, model_id } = JSON.parse(SelectCar);
                const { store_id } = JSON.parse(SelectStore);

                const response = await axios.post(`${ApiBasUrl}/get_service_addons.php`, {
                    service_id,
                    brand_id,
                    model_id,
                    store_id
                });

                const addons = response.data.addons;
                const isAddOil = addons.filter(item => item.addon_type === "oil");
                setSelectOil(isAddOil[0]);
                setServiceList(addons || []);

            } catch (error) {
                console.error("Error fetching service addons:", error);
            } finally {
                setApiLoading(false);
            }
        } else {
            setPackageCartItem([{ ...itemcopy, totalcart: 1 }]);
            setStatus(true);
        }
    };

    const HandleAddCart = (item, index) => {
        const addon_id = item.addon_id;
        let TotalPrice;

        if (item.addon_type === "oil") {
            setSelectOil(item);
            return;
        }

        if (addcart.includes(addon_id)) {
            const FilterCart = addcart.filter(item => addon_id !== item);
            setAddCart(FilterCart);
            TotalPrice = totalcartprice - item.price;
            setTotalCart(totalcart - 1);
            const Copy = [...cartitem];
            Copy.splice(index, 1);
            setCartItem(Copy);
        } else {
            TotalPrice = totalcartprice + item.price;
            setTotalCart(totalcart + 1);
            HandleAddToCart();
            setCartItem([...cartitem, item]);
            setAddCart([...addcart, addon_id]);
        }
        setTotalCartPrice(TotalPrice);
    };

    const HandleAddToCart = () => {
        setPackageCartItem([...packagecartitem, { ...itemcopy, totalcart: 1, addon_id: selectoil.addon_id }]);
        setStatus(true);
    };

    useEffect(() => {

        const Data = selectoil ? [...cartitem, selectoil] : [...cartitem];
        const combinedCartItems = { packagecartitem: [...packagecartitem], cartitem: Data };
        const combineLength = [...packagecartitem, ...Data];

        if (combineLength.length > 0) {
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(combinedCartItems), SECRET_KEY).toString();
            localStorage.setItem('Cartitem', encrypted);
        } else {
            localStorage.removeItem("Cartitem");
        }

        setTotalCart(combineLength.length);

    }, [packagecartitem, cartitem]);

    const handleShowVideoPrev = (index) => {
        setShowLightBox(true);
        setLightBoxIndex(index);
    };

    return (
        <div>
            <div className=" my-[30px]">
                {loading ?
                    <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                        <div className="loader2"></div>
                    </div>
                    : <div className="pb-[30px]">

                        <div className="slider-container pb-[20px]">
                            <Slider {...settings}>
                                {banner?.map((item, index) => {
                                    const videoTypes = ['mp4', 'mkv', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mpeg', 'mpg', '3gp', 'm2ts', 'mts'];
                                    const fileExt = item.split('.').pop().toLowerCase();

                                    if (videoTypes.includes(fileExt)) {
                                        return (
                                            <video onClick={() => handleShowVideoPrev(index)}
                                                key={index}
                                                autoPlay
                                                muted
                                                loop
                                                className="rounded-[15px] object-cover h-[350px] max-_430_:h-[250px] cursor-pointer"
                                            >
                                                <source src={ImgBasUrl + item} type={`video/${fileExt === 'mkv' ? 'x-matroska' : fileExt}`} />
                                            </video>
                                        );
                                    } else {
                                        return (
                                            <ImgLoad index={index} url={ImgBasUrl + item} customestyle={"w-full h-[350px] cursor-pointer max-_430_:h-[250px] object-cover rounded-[15px]"} setLightBoxIndex={setLightBoxIndex} setShowLightBox={setShowLightBox} />
                                        );
                                    }
                                })}
                            </Slider>
                        </div>

                        <div className="w-[50%] mx-auto max-_770_:w-[90%] max-_1025_:w-[70%] max-_1305_:w-[60%]">

                            <div className="bg-white py-[10px] px-[20px] rounded-[10px]">
                                <div className="flex items-center gap-[10px]">
                                    <Link to="/category-details">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                                        </svg>
                                    </Link>
                                    <h1 className="text-[22px] font-bold">{title}</h1>
                                </div>
                                <div className="mt-[20px]">
                                    {tag.map((item, index) => {
                                        return <div key={index} className="flex items-center gap-[10px] py-[5px]">
                                            <div className="bg-[#F1F2F4] p-[5px] rounded-[50px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM16.6919 12.2871C16.6539 12.3791 16.599 12.462 16.53 12.531L13.53 15.531C13.384 15.677 13.192 15.751 13 15.751C12.808 15.751 12.616 15.678 12.47 15.531C12.177 15.238 12.177 14.763 12.47 14.47L14.1899 12.75H8C7.586 12.75 7.25 12.414 7.25 12C7.25 11.586 7.586 11.25 8 11.25H14.189L12.469 9.53003C12.176 9.23703 12.176 8.76199 12.469 8.46899C12.762 8.17599 13.237 8.17599 13.53 8.46899L16.53 11.469C16.599 11.538 16.6539 11.6209 16.6919 11.7129C16.7679 11.8969 16.7679 12.1031 16.6919 12.2871Z" fill="#25314C" />
                                                </svg>
                                            </div>
                                            <h1 className='text-[17px]'>{item}</h1>
                                        </div>
                                    })}
                                </div>
                            </div>

                            <h1 className="text-[24px] font-bold py-[10px]">{t("What's Included")}</h1>

                            <div className="bg-white py-[10px] px-[20px] rounded-[10px]">
                                <h1 className="font-[500] text-[19px]">{t("Essential Services")}</h1>

                                <div className="mt-[10px]">
                                    {whatsinclude.split(",").map((item, index) => {
                                        return <div key={index} className="flex items-center gap-[10px] py-[3px]">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM16.6919 12.2871C16.6539 12.3791 16.599 12.462 16.53 12.531L13.53 15.531C13.384 15.677 13.192 15.751 13 15.751C12.808 15.751 12.616 15.678 12.47 15.531C12.177 15.238 12.177 14.763 12.47 14.47L14.1899 12.75H8C7.586 12.75 7.25 12.414 7.25 12C7.25 11.586 7.586 11.25 8 11.25H14.189L12.469 9.53003C12.176 9.23703 12.176 8.76199 12.469 8.46899C12.762 8.17599 13.237 8.17599 13.53 8.46899L16.53 11.469C16.599 11.538 16.6539 11.6209 16.6919 11.7129C16.7679 11.8969 16.7679 12.1031 16.6919 12.2871Z" fill="#25314C" />
                                            </svg>
                                            <h1 className='text-[17px]'>{item}</h1>
                                        </div>
                                    })}
                                </div>
                            </div>

                            {additional && <div className="bg-white py-[10px] px-[20px] rounded-[10px] mt-[20px]">
                                <h1 className="font-[500] text-[19px]">{t("Additional Service")}</h1>

                                <div className="mt-[10px]">
                                    {additional.split(",").map((item, index) => {
                                        return <div key={index} className="flex items-center gap-[10px] py-[3px]">
                                            <div className="bg-green-600 rounded-[50px]">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white" />
                                                </svg>
                                            </div>
                                            <h1 className='text-[17px]'>{item}</h1>
                                        </div>
                                    })}
                                </div>
                            </div>}

                            {faqList.length >= 1 && <div className="bg-white py-[10px] px-[20px] rounded-[10px] mt-[20px]">
                                <h1 className="font-[500] text-[19px]">{t("Frequently Asked Questions")}</h1>

                                <div className="mt-[10px]">
                                    {faqList.map((item, index) => {
                                        return (
                                            <div key={index} className="mb-[8px]">
                                                <Accordion style={{
                                                    boxShadow: 'none',
                                                    border: '1px solid #8080803b', borderRadius: "10px", padding: "10px 0"
                                                }} expanded={expandedIndex === index} onChange={() => handleChange(index)}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls={`panel${index}-content`}
                                                        id={`panel${index}-header`}
                                                    >
                                                        <Typography className='max-_430_:text-[14px]' component="span">{item.question}</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails className='max-_430_:text-[14px]'>{item.answer}</AccordionDetails>
                                                </Accordion>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>}

                        </div>
                    </div>}
            </div>

            {isshow && <div onClick={() => setIsShow(false)} className="bottem_sheet items-end">
                <div onClick={(e) => e.stopPropagation()} className="bottem_box overflow-hidden">
                    <div className="max-h-[800px] scroll-container">
                        {apiloading
                            ? <div className="h-[500px] flex items-center justify-center">
                                <div className="loader2"></div>
                            </div>
                            : <div>
                                <div className="">
                                    <div className="text-center leading-[20px] bg-[#F1F2F4] py-[15px]">
                                        <h1 className="text-[19px] font-bold">{t("Basic Service")}</h1>
                                        <p className="font-[500] text-gray-500">{t("Select Engine oil")}</p>
                                    </div>
                                    <div className="flex items-center gap-[10px] px-[15px] py-[10px] scroll-container">
                                        {servicelist.map((item, index) => {
                                            if (item.addon_type === "oil") {
                                                return (<div key={index} onClick={() => HandleAddCart(item, index)} className={`min-w-[50%] max-w-[50%] duration-[0.5s] ${selectoil.addon_id === item.addon_id && "border-[#682afb]"} border-[2px] rounded-[10px] cursor-pointer`}>
                                                    <div className="p-[10px]">
                                                        <h1 className='font-[500] text-[16px] mb-[10px]'>{item.title}</h1>
                                                        <img src={ImgBasUrl + item.img} className='w-[50px] h-[50px] object-contain' alt="img" />
                                                        <p className='text-[15px]'>{item.subtitle.slice(0, 50)}</p>
                                                    </div>

                                                    <div className="border-t-[1px] "></div>

                                                    <div className="px-[10px] py-[5px] flex items-center gap-[10px] justify-between">
                                                        <h1 className='font-bold text-[15px] text-gray-700'>{item.price === 0 ? t("Free") : `${Currency}${item.price}`}</h1>
                                                        <div className={`w-[18px] h-[18px] duration-[0.5s] border-[2px] overflow-hidden p-[2px] rounded-full ${selectoil.addon_id === item.addon_id && "border-[#682afb]"}`}>
                                                            <div className={`w-full h-full duration-[0.5s] rounded-full ${selectoil.addon_id === item.addon_id && "bg-[#682afb]"}`}></div>
                                                        </div>
                                                    </div>
                                                </div>)
                                            }
                                        })}
                                    </div>
                                </div>
                                <div className="">
                                    <div className="text-center leading-[20px] bg-[#F1F2F4] py-[15px]">
                                        <h1 className="text-[19px] font-bold">{t("Boost Your Service")}</h1>
                                        <p className="font-[500] text-gray-500">{t("For better performance & mileage")}</p>
                                    </div>
                                    <div className="px-[15px] py-[10px]">
                                        {servicelist.map((item, index) => {
                                            if (item.addon_type === "normal") {
                                                return <ServiceItemNormal key={index} index={index} item={item} Currency={Currency} ImgBasUrl={ImgBasUrl} HandleAddCart={HandleAddCart} AddCartData={addcart} />
                                            }

                                        })}
                                    </div>
                                </div>
                            </div>}
                    </div>

                    {!apiloading && <div className="bg-[#682afb] px-[15px] py-[10px]">
                        <div className="flex items-center justify-between text-white">
                            <h1 className="font-bold ">{Currency}{!apiloading ? price + totalcartprice + selectoil?.price : 0}</h1>
                            <button onClick={() => { HandleAddToCart(); setIsShow(false) }} className="font-[500]">{t("ADD TO CART")}</button>
                        </div>
                    </div>}

                </div>
            </div>}

            {(!loading && Userid) && <div className="fixed bottom-[10px] left-0 right-0">
                <div className="flex items-center justify-center">
                    <div className="w-[50%] mx-auto max-_770_:w-[90%] max-_1025_:w-[70%] max-_1305_:w-[60%] bg-[#682afb] py-[8px] px-[15px] inline-block rounded-[5px]">
                        <div className="flex items-center justify-between w-full">
                            <h1 className='font-bold text-white text-[17px]'>{Currency}{price}</h1>
                            <button onClick={handleAddToCart} className="flex items-center gap-[5px]">
                                <h1 className='font-[500] text-white'>{status ? t("VIEW CART") : t("ADD TO CART")}</h1>
                                <svg width="14" height="14" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.35401 5.35401L1.35401 9.35401C1.25601 9.45201 1.12801 9.50001 1.00001 9.50001C0.87201 9.50001 0.744006 9.45101 0.646006 9.35401C0.451006 9.15901 0.451006 8.84198 0.646006 8.64698L4.292 5.00099L0.646006 1.35499C0.451006 1.15999 0.451006 0.842959 0.646006 0.647959C0.841006 0.452959 1.15804 0.452959 1.35304 0.647959L5.35304 4.64796C5.54904 4.84196 5.54901 5.15801 5.35401 5.35401Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>}

            <Lightbox
                open={showlightbox}
                close={() => setShowLightBox(false)}
                slides={lightboximg}
                index={lightboxindex}
                plugins={[Zoom, Video]}
            />

        </div>
    )
}

export default Details

const ServiceItemNormal = ({ index, item, ImgBasUrl, Currency, AddCartData, HandleAddCart }) => {

    const { t } = useTranslation();

    const [showdetaisl, setShowDetails] = useState(false);
    const isSelected = AddCartData.includes(item.addon_id);

    return (
        <div onClick={() => HandleAddCart(item, index)} className={`border-[1px] ${isSelected ? "border-[#682afb]" : "border-gray-400"} rounded-[10px] mt-[5px] cursor-pointer`}>
            <div className="flex items-center gap-[10px] px-[10px] py-[5px]">
                <img src={ImgBasUrl + item.img} className="w-[70px] h-[70px] object-contain" alt="" />
                <div className="">
                    <h1 className="font-[500] text-[17px]">{item.title}</h1>
                    <p className="text-gray-600">{item.subtitle}</p>
                </div>
            </div>
            {showdetaisl && <div className="border-t-[1px] border-b-[1px] py-[5px] border-gray-400 px-[10px]">
                {item.tags.map((item, index) => {
                    return <div key={index} className="flex items-center gap-[5px] mt-[5px]">
                        <div className="bg-gray-200 p-[5px] rounded-[50px]">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM16.6919 12.2871C16.6539 12.3791 16.599 12.462 16.53 12.531L13.53 15.531C13.384 15.677 13.192 15.751 13 15.751C12.808 15.751 12.616 15.678 12.47 15.531C12.177 15.238 12.177 14.763 12.47 14.47L14.1899 12.75H8C7.586 12.75 7.25 12.414 7.25 12C7.25 11.586 7.586 11.25 8 11.25H14.189L12.469 9.53003C12.176 9.23703 12.176 8.76199 12.469 8.46899C12.762 8.17599 13.237 8.17599 13.53 8.46899L16.53 11.469C16.599 11.538 16.6539 11.6209 16.6919 11.7129C16.7679 11.8969 16.7679 12.1031 16.6919 12.2871Z" fill="#25314C" />
                            </svg>
                        </div>
                        <h1 className="text-[15px]">{item}</h1>
                    </div>
                })}
            </div>}
            <div className="flex items-center justify-between px-[10px] py-[5px]">
                <div className="flex items-center gap-[15px]">
                    <button className="flex items-center gap-[10px]">
                        <div className={`border-[2px] border-[#682afb] ${isSelected && "bg-[#682afb]"} rounded-[5px]`}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white" />
                            </svg>
                        </div>
                        <h1 className="font-[500] text-[#682afb]">{isSelected ? t("ADDED") : t("ADD")}</h1>
                    </button>
                    <h1 className="font-[500] text-[15px]">{Currency}{item.price}</h1>
                </div>
                <button onClick={(e) => { e.stopPropagation(); setShowDetails(!showdetaisl) }} className="border-[1px] rounded-[50px] border-gray-400">
                    {showdetaisl
                        ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 14.75C15.808 14.75 15.616 14.6771 15.47 14.5301L12 11.0601L8.53005 14.5301C8.23705 14.8231 7.76202 14.8231 7.46902 14.5301C7.17602 14.2371 7.17602 13.762 7.46902 13.469L11.469 9.46902C11.762 9.17602 12.2371 9.17602 12.5301 9.46902L16.5301 13.469C16.8231 13.762 16.8231 14.2371 16.5301 14.5301C16.3841 14.6771 16.192 14.75 16 14.75Z" fill="#25314C" />
                        </svg>
                        : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z" fill="#25314C" />
                        </svg>}
                </button>
            </div>
        </div>);
};

const ImgLoad = ({ index, url, customestyle, setShowLightBox, setLightBoxIndex }) => {

    const [imgLoaded, setImgLoaded] = useState(false);

    const handleShowImgPrev = () => {
        setShowLightBox(true);
        setLightBoxIndex(index);
    }

    return (
        <img
            onClick={handleShowImgPrev}
            src={url}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${customestyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    )
}

/* jshint ignore:end */
